import { render, staticRenderFns } from "./PresentationToolbelt.vue?vue&type=template&id=3bfb460d"
import script from "./PresentationToolbelt.vue?vue&type=script&lang=js"
export * from "./PresentationToolbelt.vue?vue&type=script&lang=js"
import style0 from "./PresentationToolbelt.vue?vue&type=style&index=0&id=3bfb460d&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports